import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import FormulasWishListPage from './formulas-wish-list'

const formulaWishListRoutes: Route[] = [
  {
    path: Paths.SETTING_FORMULA_WISH_LIST,
    element: <FormulasWishListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default formulaWishListRoutes
